import { Switch } from "@headlessui/react";
import React, { useEffect, useState } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
type Props = {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
};

const SwitchButton = ({ value, onChange, disabled = false }: Props) => {
  return (
    <Switch
      checked={value}
      onChange={onChange}
      disabled={disabled}
      className={tw`${value ? "bg-[#68D391]" : "bg-gray-300"}
        relative inline-flex h-5 w-8 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
    >
      <span
        aria-hidden="true"
        className={tw`${value ? "translate-x-3" : "translate-x-0"}
          pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
      />
    </Switch>
  );
};

export default SwitchButton;
